import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {InfluencerConfirmationForm} from '../../../../models/influencer';
import {InfluencerService} from '../../../services/influencer/influencer.service';
import {ValidationHandlerService} from '../../../core/validation-handler.service';
import {ErrorTemplate} from '../../../../models/ErrorTemplate';
import {UserService} from '../../../services/user.service';
import * as Sentry from '@sentry/browser';
import {
  ActionDetails,
  ActionSource,
  EventTrackerService,
  Page,
  TargetType,
  UserActionType
} from '../../../services/event-tracker/event-tracker.service';

@Component({
  selector: 'influencer-confirmation',
  templateUrl: './influencer-confirmation.component.html',
  styleUrls: ['./influencer-confirmation.component.scss']
})
export class InfluencerConfirmationComponent implements OnInit {
  @Output() acceptCallback: EventEmitter<any> = new EventEmitter<any>();
  @Output() errorCallback: EventEmitter<any> = new EventEmitter<any>();
  influencer: InfluencerConfirmationForm;
  acceptedTermAndService = false;
  isTermAndConditionError: boolean;
  public fieldErrors: ErrorTemplate[] = [];
  constructor(private userService: UserService,
              private influencerService: InfluencerService,
              private validationErrorHandler: ValidationHandlerService,
              private eventTracker: EventTrackerService) { }

  ngOnInit() {
    const currentInfluencer = this.userService.getInfluencerInfo();
    if (currentInfluencer) {
      this.influencer = new InfluencerConfirmationForm(currentInfluencer.name, currentInfluencer.email);
      this.acceptedTermAndService = currentInfluencer.acceptedTermService;
    }
  }

  onSubmit() {
    const currentInfluencer = this.userService.getInfluencerInfo();
    if (!currentInfluencer) {
      return;
    }
    const errors = this.influencerService.validateInfluencerConfirmationData(this.influencer, this.acceptedTermAndService);
    if (errors.length > 0) {
      this.fieldErrors = errors;
      this.isTermAndConditionError = this.fieldErrors.filter(e => e.name === 'influencer.acceptedTermAndService').length > 0;
      this.validationErrorHandler.shouldDisplayErrors(true);
      this.validationErrorHandler.updateErrors(errors);
      return;
    }
    this.acceptCallback.emit();
    this.influencerService.confirmInfluencer(currentInfluencer.id, this.influencer).subscribe(res => {
      this.influencerService.confirmedInfluencerNameAndEmail();
      this.eventTracker.trackUserAction(UserActionType.ACTION, Page.INFLUENCER, {
        type: TargetType.INFLUENCER,
        id: currentInfluencer.id,
        name: this.influencer.fullName,
      },
      {
        actionDetails: ActionDetails.CONFIRMED_DETAILS,
        source: ActionSource.CAMPAIGN_LANDING_PAGE,
        influencerId: currentInfluencer.id,
        action: UserActionType.UPDATE
      }, undefined, null);
    }, (err) => {
      this.errorCallback.emit();
      // Report to Sentry
      Sentry.captureException(err);
    });
  }

  onUpdateTermAndServiceAgreement(evt) {
    const isAcceptedTerm = this.acceptedTermAndService;
    this.fieldErrors = this.fieldErrors.filter(err => err.name !== 'influencer.acceptedTermAndService');
    this.acceptedTermAndService = !isAcceptedTerm;
    this.isTermAndConditionError = false;
  }

  clearError(keyParam) {
    this.fieldErrors = this.fieldErrors.filter(e => e.name !== keyParam);
  }
}



// WEBPACK FOOTER //
// ./src/app/influencer-platform/influencer-details/influencer-confirmation/influencer-confirmation.component.ts